// 引入api
import { fun_PostAction } from "@/api";
// 引入武汉市地图json
import WuhanJson from "@/utils/mapJson/wuhan.json";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: null,
      // tab切换数据
      tabList: [
        { name: "2025年项目数据汇总分析", value: "2025" },
        { name: "2024年项目数据汇总分析", value: "2024" },
      ],
      // 当前选中
      tabActive: "2025",
      // 已完成项目类型数量及占比数据
      progressList: [
        { name: "工程总承包招标", value: "0" },
        { name: "工程施工招标", value: "0" },
        { name: "工程货物招标", value: "0" },
        { name: "工程服务招标", value: "0" },
      ],
      // 获取数据最大值 默认1000
      leftChartMax: 1000,
      // 已完成项目类型数量及占比图表配置
      leftOption: {
        //你的代码
        title: {
          // text: '{a|' + rate + '%}\n{b|占比}', // 显示标题
          text: '{a|%}\n{b|占比}', // 显示标题
          show: true, // 是否显示
          x: 'center', // x轴位置
          y: 'center', // y轴位置
          textStyle: { // 样式配置
            rich: {
              a: {
                fontSize: 14, // 字体大小
                color: '#333333', // 字体颜色
                padding: [0, 0, 5, 0], // 边距
              },
              b: {
                fontSize: 10, // 字体大小
                color: '#808080', // 字体颜色
              },
            },
          },
        },
        // 提示框组件
        tooltip: {
          show: false // 是否显示
        },
        angleAxis: {
          max: 1000,
          clockwise: false, // 逆时针
          // 隐藏刻度线
          show: false,
          // 开始的角度  
          startAngle: 0
        },
        radiusAxis: {
          type: 'category',
          show: true,
          axisLabel: {
            show: false, // 是否显示标签
          },
          axisLine: {
            show: false, // 是否显示轴线
          },
          axisTick: {
            show: false, // 是否显示刻度
          },
        },
        polar: [
          {
            center: ['50%', '50%'], //中心点位置
            radius: '180%' //图形大小
          }
        ],
        series: [
          {
            type: 'bar',
            z: 10,
            data: [], // 数据
            coordinateSystem: 'polar', // 坐标
            roundCap: true, // 是否在环形柱条两侧使用圆弧效果
            barWidth: 6, // 大的占比环
            itemStyle: { // 图形样式
              normal: {
                color: "#2A91D9",
              }
            }
          },
          {
            type: 'pie',
            name: '内层细圆环',
            radius: ['70%', '85%'], // 饼图的半径
            hoverAnimation: false, // 悬浮突出
            itemStyle: { // 图形样式
                color: "#DFE0EF", // 颜色
            },
            // 提示框组件
            tooltip: {
              show: false // 是否显示
            },
            // 文本标签
            label: {
              show: false // 是否显示
            },
            data: []
          }
        ]
      },
      // 用于左侧图表实例
      chartInstances: {},
      // 中间地图图表配置
      middleOption: {
        tooltip: { // 鼠标移入后展示数据
          show: true, // 是否显示提示框组件
          trigger: 'item', // item.数据项图形触发(主要在散点图) axis.坐标轴触发(主要在柱状图) none.什么都不触发
          triggerOn: 'mousemove', // 提示框触发的条件 mousemove.鼠标移动时触发 click.鼠标点击时触发 mousemove|click.同时鼠标移动和点击时触发 none.什么都不触发
          textStyle: {
            fontSize: 16 // 提示框字体大小
          },
          // formatter: '{b}<br/>{c} (件)', // 提示框浮层内容格式器
          formatter: function (params) {
            const val = params.data
            let text = val.name + "<br />" + val.value
            return text
          }
        },
        series: [ // 地图参数
          {
            type: 'map', // 地图类型
            map: 'wuhan', // 对应 registerMap 中的 mapName 名称
            roam: true, // 是否开启平滑缩放
            zoom: 1, // 当前视角内的缩放比例
            layoutCenter: ['50%', '50%'], // 地图中心在屏幕中的位置
            layoutSize: '100%', // 地图的大小(支持相对于屏幕宽高的百分比或者绝对的像素大小)
            selectedMode: 'single', // 单选模式
            itemStyle: {
              normal: { // 鼠标移入前的样式 - 注：使用颜色梯度时注释掉
                borderWidth: 1, // 图形的描边线宽
                borderColor: '#FFFFFF', // 图形的描边颜色
                areaColor: '#D0D1DD',// 地图(底图)区域的颜色
                color: '#D0D1DD', // 图形的颜色(背景颜色)
                label: { // 图形上的文本标签
                  show: true, // 显示文本标签
                  formatter: function (params) {
                    // 定义富文本样式
                    return `{a|${params.value}}\n{b|${params.name}}`;
                  },
                  rich: {
                    a: { color: '#0E70B5', fontSize: 16, fontWeight: "600" }, // 数值颜色
                    b: { color: '#000000' }  // 名称颜色
                  }
                }
              },
              emphasis: { // 鼠标移入后的样式
                areaColor: {
                  type: 'linear',
                  x: 0, y: 0, x2: 0, y2: 1, // 从上到下渐变
                  colorStops: [
                    { offset: 0, color: '#6DBAF2' }, 
                    { offset: 1, color: '#3494D6' }  
                  ]
                },
                borderWidth: 2, // 图形的描边线宽
                borderColor: '#FFFFFF', // 图形的描边颜色
                shadowColor: "rgba(0,0,0,0.16)", // 阴影
                shadowBlur: 5, // 阴影模糊度
                shadowOffsetX: 2, // 水平阴影偏移
                shadowOffsetY: 2, // 垂直阴影偏移
                label: { // 图形上的文本标签
                  formatter: function (params) {
                    // 定义富文本样式
                    return `{a|${params.value}}\n{b|${params.name}}`;
                  },
                  rich: {
                    a: { color: '#ffffff' }, 
                    b: { color: '#ffffff' }  
                  }
                }
              }
            },
            select: { // 地图选中区域样式
                itemStyle: {
                  areaColor: {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1, // 从上到下渐变
                    colorStops: [
                      { offset: 0, color: '#6DBAF2' }, 
                      { offset: 1, color: '#3494D6' }  
                    ]
                  }
                },
                label: { // 图形上的文本标签
                  rich: {
                    a: { color: '#ffffff' }, 
                    b: { color: '#ffffff' }  
                  }
                }
            },
            data: []
          }
        ]
      },
      // 武汉地图
      mapChart: null,
      // form字段
      form: {
        // 招标人数量
        tendereeNum: null,
        // 投标人数量
        tendererNum: null,
        // 已完成招标项目数量（个）
        completedProjectCount: null,
        // 正在进行招标项目数量（个）
        projectCount: null,
        // 己完成中标金额（亿）
        funds: null,
        // 直接发包项目个数（个）
        contractProjectCount: null,
        // 直接发包总金额（亿）
        contractFunds: null,
        // 更新时间
        insertDate: null,
      },
      zoneList:[], // 各区的数量
      clickZoneFlag: "0", // 点击地图标志
      clickZoneName: null, // 点击所属区名称
    };
  },
  watch: {
    progressList: {
      deep: true,
      handler(newVal) {
        // 初始化图表
        this.fun_GetLeftInitChart();
      }
    }
  },
  created() {
  },
  // 注册组件
  components: {
  },
  // 组件销毁之前
  beforeDestroy() {
    // 清除左侧动态图表
    this.fun_GetClearAllCharts();
    window.removeEventListener('resize', this.fun_GetLeftInitChart, this.fun_GetInfoMapChart);
    // 判断是否初始化成功
    if (!this.mapChart) {
      // 不成功则返回
      return;
    }
    // 销毁
    this.mapChart.dispose();
    // 销毁
    this.mapChart = null;
  },
  // 模板编译完成
  mounted() {
    // 获取当年年份
    const year = new Date().getFullYear();
    // 前一年
    let previouYear = year - 1;
    // 设置表头
    this.tabList = [
      { name: year + "年项目数据汇总分析", value: year },
      { name: previouYear + "年项目数据汇总分析", value: previouYear },
    ];
    // 当前选中
    this.tabActive = year;
    // 获取数据
    this.fun_GetProjectStatistics(this.tabActive, "");
  },
  methods: {
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      // 全局加载
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    },
     /**
     * 项目数据统计
     * @params e 点击的行数据
     * @author 付翔
     */
     fun_GetProjectStatistics(e, code, click) {
       // 清空各区的数量
       this.zoneList = [],
       // 全局加载
       this.fun_Loading();
       // 请求，获取结果集
       fun_PostAction("/auditHome/projectStatistics", {
         year: e, // 年份
         code: code // 行政区划
       }).then(res => {
         // 解构res.data
         const { result, data } = res.data;
         // 关闭加载
         this.fullLoading.close();
         // 返回成功
         if(result){
           // 赋值
           this.form = data.data;
           // 遍历
           this.progressList.map(e => {
             // 工程总承包招标
             if(e.name == "工程总承包招标"){
               e.value = data.data.generalContractingNum;
               e.num = data.data.generalContractingZb;
             }
             // 工程施工招标
             else if(e.name == "工程施工招标"){
               e.value = data.data.constructionNum;
               e.num = data.data.constructionZb;
             }
             // 工程货物招标
             else if(e.name == "工程货物招标"){
               e.value = data.data.goodsNum;
               e.num = data.data.goodsZb;
             }
             // 工程服务招标
             else if(e.name == "工程服务招标"){
               e.value = data.data.serviceNum;
               e.num = data.data.serviceZb;
             }
           });
           // 设置江岸区
           this.zoneList.push({code: "420102", name: "江岸区", value: data.data.jiangAn});
           // 设置江汉区
           this.zoneList.push({code: "420103", name: "江汉区", value: data.data.jiangHan});
           // 设置硚口区
           this.zoneList.push({code: "420104", name: "硚口区", value: data.data.qiaoKou});
           // 设置汉阳区
           this.zoneList.push({code: "420105", name: "汉阳区", value: data.data.hanYang});
           // 设置武昌区
           this.zoneList.push({code: "420106", name: "武昌区", value: data.data.wuChang});
           // 设置青山区
           this.zoneList.push({code: "420107", name: "青山区", value: data.data.qingShan});
           // 设置洪山区
           this.zoneList.push({code: "420111", name: "洪山区", value: data.data.hongShan});
           // 设置东西湖区
           this.zoneList.push({code: "420112", name: "东西湖区", value: data.data.dongXiHu});
           // 设置汉南区
           this.zoneList.push({code: "420113", name: "汉南区", value: data.data.hanNan});
           // 设置蔡甸区
           this.zoneList.push({code: "420114", name: "蔡甸区", value: data.data.caiDian});
           // 设置江夏区
           this.zoneList.push({code: "420115", name: "江夏区", value: data.data.jiangXia});
           // 设置黄陂区
           this.zoneList.push({code: "420116", name: "黄陂区", value: data.data.huangPi});
           // 设置新洲区
           this.zoneList.push({code: "420117", name: "新洲区", value: data.data.xinZhou});
           // 如果是点击所属区
           if(!click){
             this.$nextTick(()=>{
               // 数据加载
               this.fun_GetProject();
             })
           }
         }

      });
    },
    /**
     * 数据加载
     */
    fun_GetProject(){
      // 初始化图表
      this.fun_GetLeftInitChart();
      // 初始化武汉地图图表
      this.fun_GetInfoMapChart();
      // 设置各区项目数量
      window.addEventListener('resize', this.fun_GetLeftInitChart, this.fun_GetInfoMapChart);
    },
    /**
     * 初始化左侧图表
     */
    fun_GetLeftInitChart() { 
      // 遍历
      this.progressList.map((e, i) => {
        // 判断是否存在
        if(this.chartInstances && this.chartInstances['leftEcharts' + i]) this.chartInstances['leftEcharts' + i].resize();
        // 获取标签
        const chart = this.$echarts.init(document.getElementById("leftEcharts" + i));
        // 存储实例
        this.chartInstances['leftEcharts' + i] = chart; 
        // 获取配置
        var option = this.leftOption;
        // 修改配置
        option.title.text = "{a|" + e.num + "%}\n{b|占比}"; // 显示标题
        option.angleAxis.max = this.leftChartMax; // 最大 设置最大值进度不会填满
        option.series[0].data = [e.value]; // 占比数量用于环形进度
        option.series[1].data = [this.leftChartMax]; // 内侧设置最大 灰色圆
        chart.setOption(option);
      })
    },
    /**
     * 初始化武汉地图图表
     */
    fun_GetInfoMapChart() {
      // 设置各区数量
      var mapArray = this.zoneList;
      // 获取数据的value
      const values = mapArray.map(item => item.value);
      // 找到最大值
      const max = Math.max(...values);
      // 找到最小值
      const min = Math.min(...values);
      // 动态设置颜色
      const processedData = mapArray.map(item => {
        // 声明
        let color;
        // 判断最大值
        if (item.value === max) color = '#9AC5EE'; // 最大值颜色
        // 判断最小值
        else if (item.value === min) color = '#DFE0EF'; // 最小值颜色
        // 其他
        else color = '#E0EAF5'; // 其他颜色
        // 返回数据
        return { ...item, itemStyle: { areaColor: color } };
      });
      // 判断是否存在
      if(this.mapChart) this.mapChart.resize();
      // 注册地图JSON文件
      this.$echarts.registerMap("wuhan", WuhanJson);
      this.mapChart = this.$echarts.init(document.getElementById("echarts"));
      // 配置数据
      this.middleOption.series[0].data = processedData;
      // 设置echarts选项
      this.mapChart.setOption(this.middleOption);
      // 取消所有选中
      this.mapChart.dispatchAction({
        type: 'unselect',
        name: this.clickZoneName
      });
      // 解除绑定的点击事件
      this.mapChart.off("click");
      // 存储this
      var that = this;
      // 添加点击事件
      this.mapChart.on('click', function(params) {
        // 设置所属区名称
        that.clickZoneName = params.data.name;
        // 判断点击的是否为当前选中
        if(that.clickZoneFlag && that.clickZoneFlag === params.data.code){ // 获取所有数据
          // 清空当前选中
          that.clickZoneFlag = null;
          // 执行方法获取全部
          that.fun_GetProjectStatistics(that.tabActive, "", "");
        }
        // 判断当前选中并且点击的不是已经选中的地区
        else { // 点击的区
          // 获取当前选中的地区
          that.clickZoneFlag = params.data.code;
          // 执行方法获取选中地区数据
          that.fun_GetProjectStatistics(that.tabActive, that.clickZoneFlag, "click");
        }
      });
    },
    /**
     * 清除动态图表
     */
    fun_GetClearAllCharts() {
      Object.values(this.chartInstances).forEach(instance => {
        instance?.dispose(); // 安全调用 dispose 方法
      });
      this.chartInstances = {}; // 清空引用
    },
    /**
     * tab点击切换方法
     * @param {*} val 点击的数据
     */
    fun_GetClickTab(val) { 
      // 判断是否为当前选中
      if (this.tabActive === val.value) return;
      // 获取当前选中的value
      this.tabActive = val.value;
      if(this.mapChart){
        console.log("1")
        // 取消所有选中
        // this.mapChart.dispatchAction({
        //   type: 'mapUnSelect'
        // });
        // 取消选中状态
        // this.mapChart.clearSelected();
      }
      // 获取数据
      this.fun_GetProjectStatistics(val.value, "")
    },
  }
};
